import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/trade-banner.png'


const _withScopeId = n => (_pushScopeId("data-v-233ace41"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-min-h-[292px] tw-relative sm:!tw-min-h-[232px]" }
const _hoisted_2 = { class: "tw-min-h-[150px] tw-w-full tw-p-4 tw-box-border tw-rounded-lg tw-bg-[#F8FBFD] tw-border-[1px] tw-border-[#DFDFDF] tw-border-solid tw-overflow-hidden tw-relative sm:!tw-min-h-[140px]" }
const _hoisted_3 = { class: "tw-w-full tw-h-full tw-absolute tw-top-0 tw-right-0" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "tw-w-full tw-h-full tw-object-cover"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "tw-w-full tw-h-auto tw-flex tw-items-start tw-justify-between" }
const _hoisted_7 = { class: "tw-flex tw-flex-col tw-items-start tw-gap-2" }
const _hoisted_8 = { class: "tw-min-h-[182px] tw-bg-transparent tw-w-full tw-p-4 tw-box-border tw-flex tw-gap-4 tw-items-end tw-absolute tw-bottom-0 sm:!tw-min-h-[unset] sm:!tw-gap-[.6rem]" }
const _hoisted_9 = {
  key: 1,
  class: "tw-min-w-[150px] tw-h-[150px] tw-overflow-hidden tw-rounded-[10.67px] sm:!tw-min-w-[98px] sm:!tw-w-[98px] sm:!tw-h-[98px]"
}
const _hoisted_10 = { class: "tw-w-full tw-h-full tw-flex tw-items-end tw-pb-4 tw-box-border md:!tw-pb-0" }
const _hoisted_11 = { class: "tw-w-full tw-flex tw-items-start tw-justify-between tw-gap-2" }
const _hoisted_12 = { class: "tw-flex tw-flex-col tw-gap-3 tw-items-start sm:!tw-gap-0 md:!tw-gap-[.3rem]" }
const _hoisted_13 = { class: "view-rating-box md:tw-gap-[.3rem]" }
const _hoisted_14 = { class: "tw-flex tw-space-x-2" }

import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import Text from "@/core/components/ui/general/Text.vue";
import Button from "@/core/components/ui/general/Button.vue";
import UnverifiedBadge from "@/core/components/common/UnverifiedBadge.vue";
import VerifiedBadge from "@/core/components/common/VerifiedBadge.vue";
import IdNotVerifiedBadge from "@/core/components/common/IdNotVerifiedBadge.vue";
import { USER_STORE } from "@/store/modules/user";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import { WORKSTATION } from "@/store/modules/workstation";
import { UserRolesEnum } from "@/core/enums/RolesEnum";
import ProfileThumbnail from "@/core/uni-components/ProfileThumbnail.vue";
import UserProfileLogo from "@/core/components/UserProfileLogo.vue";
import { getCombineSameProjectReview } from "@/core/utils/common";
import { REVIEW_RATING_STORE } from "@/store/modules/review-rating";
import { reviewRatingState } from "@/core/models/project-rating";
// import { TRADE_PASSPOSRT_ROUTE } from "../../routes";
import { TRADE_PASSPOSRT_ROUTE } from "@/modules/trade-passport/routes";
import {
  BusinessDetailTypeEnum,
  UserVerificationStatusEnum,
} from "@/core/enums/RolesEnum";
import { ProjectRatingTypeEnum } from "@/core/enums/ProjectsEnum";
import BlueCircularPlusIcon from "@/core/components/icons/BlueCircularPlusIcon.vue";
import WorkstationVerificationModal from "@/modules/workstation/components/WorkstationVerificationModal.vue";
import EditWorkStationDetailsPopup from "../EditWorkStationDetailsPopup.vue";
import BlueCircularPencilIcon from "@/core/components/icons/BlueCircularPencilIcon.vue";
import UploadTradePassportBannerModal from "../modals/UploadTradePassportBannerModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TradePassportProfileHeader',
  props: [
  "contractorworkStationImage",
  "userWorkStationImage",
  "userWorkStationBanner",
],
  emits: ["route-to-reviews-tab"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const props = __props;

const store = useStore();
const router = useRouter();

const isShowEditWorkStationModal = ref(false);
const verificationModal = ref(false);

const showUploadBannerModal = ref(false);

const user = computed(() => store.getters[`${USER_STORE}/user`]);

const getIsOpenTradePassportasViewMode = computed(
  () => store.getters[`${TRADE_ESTIMATE_STORE}/isOpenTradePassportasViewMode`]
);

const isUserProprtyOwner = computed(
  () =>
    user.value?.role?.name === UserRolesEnum.PROPERTY_OWNER ||
    getIsOpenTradePassportasViewMode.value
);

const activeUserWorkstation = computed(() => {
  if (isUserProprtyOwner.value) {
    return store.getters[
      `${TRADE_ESTIMATE_STORE}/getContractorTradePassportDetail`
    ];
  } else {
    return store.getters[`${WORKSTATION}/activeUserWorkstation`];
  }
});

const getAllProjectReviewList = computed<
  reviewRatingState["allProjectReviewList"]
>(() => store.getters[`${REVIEW_RATING_STORE}/getAllProjectReviewList`]);

const combineSameProjectReview = computed(() =>
  getCombineSameProjectReview(getAllProjectReviewList.value)
);
const getAverageOfAllProjectReview = computed(() => {
  const totalAvg = combineSameProjectReview.value.reduce(
    (totalRating: number, review: any) => {
      totalRating += review.totalAvg || 0;
      return totalRating;
    },
    0
  );
  return totalAvg
    ? Math.round((totalAvg * 100) / combineSameProjectReview.value.length) / 100
    : totalAvg;
});

const userBusinessType = computed(() => user.value?.userBusinessDetails?.type);

const WorkStationSiltVerificationStatus = computed(
  () => store.getters[`${WORKSTATION}/getWorkStationSiltVerificationStatus`]
);

const userWorkStationStatus = computed(
  () =>
    store.getters[`${WORKSTATION}/activeUserWorkstation`]?.verificationStatus
);

const isUserVerifiedKYCAndKYB = computed(() =>
  userBusinessType.value === BusinessDetailTypeEnum.LIMITED_COMPANY
    ? WorkStationSiltVerificationStatus.value &&
      ["SUCCESS", "MANUAL_REVIEW"].includes(
        WorkStationSiltVerificationStatus.value?.status
      )
    : [
        UserVerificationStatusEnum.PENDING_VERIFICATION,
        UserVerificationStatusEnum.VERIFIED,
      ].includes(activeUserWorkstation.value?.user?.userKYCVerificationStatus)
);

const onOpenUploadBannerModal = () => {
  showUploadBannerModal.value = true;
};
const onCloseUploadBannerModal = () => {
  showUploadBannerModal.value = false;
};

const onClickIDVerificationModal = () => {
  if (isUserProprtyOwner.value) return;
  if (isUserVerifiedKYCAndKYB.value) return;
  verificationModal.value = true;
};

const onClickCloseModel = async () => {
  verificationModal.value = false;
  await store.dispatch(`${USER_STORE}/getAccountStatuses`);
};

const workstationPostcode = (type: string) => {
  if (activeUserWorkstation.value?.user) {
    return type === BusinessDetailTypeEnum.LIMITED_COMPANY
      ? activeUserWorkstation.value?.user?.userBusinessDetails?.businessPostcode
      : activeUserWorkstation.value?.user?.userBusinessDetails
          ?.residencyPostcode;
  } else {
    return "N/A";
  }
};

const workstationAddress = (type: string) => {
  if (activeUserWorkstation.value?.user) {
    let address;
    if (type === BusinessDetailTypeEnum.LIMITED_COMPANY) {
      const businessAddress =
        activeUserWorkstation.value?.user?.userBusinessDetails?.businessAddress?.replace(
          activeUserWorkstation.value?.user?.userBusinessDetails
            ?.businessPostcode,
          ""
        );
      address = businessAddress?.replace(/,([^,]*)$/, ".$1");
    } else if (
      activeUserWorkstation.value?.user?.userBusinessDetails
        ?.residencyAddressLookup
    ) {
      const residencyAddressLookup =
        activeUserWorkstation.value?.user?.userBusinessDetails?.residencyAddressLookup?.replace(
          activeUserWorkstation.value?.user?.userBusinessDetails
            ?.residencyPostcode,
          ""
        );
      address = residencyAddressLookup?.replace(/,([^,]*)$/, ".$1");
    } else {
      address = `${activeUserWorkstation.value?.user?.userBusinessDetails?.residencyAddressLine} ${activeUserWorkstation.value?.user?.userBusinessDetails?.residencyTown}`;
    }
    return address;
  } else {
    return "N/A";
  }
};

const onClickViewRatings = () => {
  // router.push({ name: TRADE_PASSPOSRT_ROUTE });
  // await store.dispatch(
  //   `${REVIEW_RATING_STORE}/setTradePassportRedirect`,
  //   "Reviews"
  // );
  console.log("clicked emits");
  emits("route-to-reviews-tab");
};

const toggleEditWorkStationModal = () => {
  isShowEditWorkStationModal.value = !isShowEditWorkStationModal.value;
};
// const onClickViewRatings = () => {
//   store.dispatch(`${REVIEW_RATING_STORE}/setTradePassportRedirect`, "Reviews");
//   router.push({ name: TRADE_PASSPOSRT_ROUTE });
// };

onMounted(async () => {
  await store.dispatch(
    `${REVIEW_RATING_STORE}/getAllProjectReviewList`,
    ProjectRatingTypeEnum.TRADER_OWNER
  );
});

return (_ctx: any,_cache: any) => {
  const _component_v_rating = _resolveComponent("v-rating")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!props.userWorkStationBanner)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true),
        (props.userWorkStationBanner)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: props.userWorkStationBanner,
              class: "tw-w-full tw-h-full tw-object-cover"
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (
              activeUserWorkstation.value?.verificationStatus ===
              _unref(UserVerificationStatusEnum).VERIFIED
            )
            ? (_openBlock(), _createBlock(VerifiedBadge, {
                key: 0,
                label: "Verified Member Since 2024"
              }))
            : (_openBlock(), _createBlock(UnverifiedBadge, { key: 1 })),
          (
              (activeUserWorkstation.value?.user?.userKYCVerificationStatus ===
                _unref(UserVerificationStatusEnum).NOT_ADDED &&
                userBusinessType.value === _unref(BusinessDetailTypeEnum).SOLETRADER &&
                activeUserWorkstation.value?.verificationStatus !==
                  _unref(UserVerificationStatusEnum).PENDING_VERIFICATION) ||
              (!WorkStationSiltVerificationStatus.value &&
                userBusinessType.value === _unref(BusinessDetailTypeEnum).LIMITED_COMPANY &&
                userWorkStationStatus.value !==
                  _unref(UserVerificationStatusEnum).PENDING_VERIFICATION)
            )
            ? (_openBlock(), _createBlock(IdNotVerifiedBadge, {
                key: 2,
                class: "tw-hidden s540:!tw-flex"
              }))
            : (_openBlock(), _createBlock(VerifiedBadge, {
                key: 3,
                label: "ID Verified",
                class: "tw-hidden s540:!tw-flex"
              }))
        ]),
        (!props.userWorkStationBanner)
          ? (_openBlock(), _createBlock(Button, {
              key: 0,
              class: "!tw-w-auto !tw-hidden rmd:!tw-inline",
              variant: "accent",
              isCapitalize: true,
              label: "+ Add Background",
              onClick: onOpenUploadBannerModal
            }))
          : _createCommentVNode("", true),
        (!props.userWorkStationBanner)
          ? (_openBlock(), _createBlock(BlueCircularPlusIcon, {
              key: 1,
              class: "tw-inline tw-z-10 rmd:!tw-hidden",
              onClick: onOpenUploadBannerModal
            }))
          : _createCommentVNode("", true),
        (props.userWorkStationBanner)
          ? (_openBlock(), _createBlock(BlueCircularPencilIcon, {
              key: 2,
              class: "tw-z-10",
              onClick: onOpenUploadBannerModal
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (props.contractorworkStationImage || props.userWorkStationImage)
        ? (_openBlock(), _createBlock(ProfileThumbnail, {
            key: 0,
            isRounded: false,
            desktopFontSizeBig: true,
            size: "xlllg",
            mobilSize: "xlg",
            isOnline: true,
            src: 
          isUserProprtyOwner.value
            ? props.contractorworkStationImage
            : props.userWorkStationImage
        
          }, null, 8, ["src"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(UserProfileLogo, {
              isRounded: false,
              desktopFontSizeBig: true,
              mobileFontSizeBig: true
            })
          ])),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(Text, {
              variant: "p",
              textWeight: "400",
              lineHeight: "18px",
              class: "rmd:!tw-text-[26px] !tw-capitalize"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(activeUserWorkstation.value?.name), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_v_rating, {
                "active-color": "orange",
                modelValue: getAverageOfAllProjectReview.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((getAverageOfAllProjectReview).value = $event)),
                color: "rgba(12, 15, 74, 0.26)",
                "empty-icon": "mdi-star",
                readonly: ""
              }, null, 8, ["modelValue"]),
              _createVNode(Text, {
                variant: "xsmall",
                textWeight: "600",
                lineHeight: "18px",
                class: "rmd:!tw-text-[14px]"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getAverageOfAllProjectReview.value) + " out of 5", 1)
                ]),
                _: 1
              }),
              _createVNode(Button, {
                label: "view Ratings",
                isCapitalize: true,
                variant: "accent",
                class: "!tw-w-auto !tw-h-[32px] !tw-min-h-[32px] sm:!tw-hidden",
                onClick: onClickViewRatings
              })
            ]),
            _createVNode(Text, {
              variant: "xsmall",
              class: "rmd:!tw-text-[14px]",
              lineHeight: "14px",
              textColor: "rgba(12, 15, 74, 0.7)",
              textAlign: "left"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(workstationAddress(
                  activeUserWorkstation.value?.user?.userBusinessDetails?.type
                ) !== "null null"
                  ? workstationAddress(
                      activeUserWorkstation.value?.user?.userBusinessDetails?.type
                    )
                  : "N/A") + " " + _toDisplayString(workstationPostcode(
                  activeUserWorkstation.value?.user?.userBusinessDetails?.type
                )), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            (
                (activeUserWorkstation.value?.user?.userKYCVerificationStatus ===
                  _unref(UserVerificationStatusEnum).NOT_ADDED &&
                  userBusinessType.value === _unref(BusinessDetailTypeEnum).SOLETRADER &&
                  activeUserWorkstation.value?.verificationStatus !==
                    _unref(UserVerificationStatusEnum).PENDING_VERIFICATION) ||
                (!WorkStationSiltVerificationStatus.value &&
                  userBusinessType.value === _unref(BusinessDetailTypeEnum).LIMITED_COMPANY &&
                  userWorkStationStatus.value !==
                    _unref(UserVerificationStatusEnum).PENDING_VERIFICATION)
              )
              ? (_openBlock(), _createBlock(IdNotVerifiedBadge, {
                  key: 0,
                  onClick: onClickIDVerificationModal,
                  class: "s540:!tw-hidden cursor-pointer"
                }))
              : (_openBlock(), _createBlock(VerifiedBadge, {
                  key: 1,
                  label: "ID Verified",
                  class: "s540:!tw-hidden"
                })),
            (!isUserProprtyOwner.value)
              ? (_openBlock(), _createBlock(BlueCircularPencilIcon, {
                  key: 2,
                  onClick: toggleEditWorkStationModal
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (verificationModal.value)
      ? (_openBlock(), _createBlock(WorkstationVerificationModal, {
          key: 0,
          onClickCloseTab: onClickCloseModel
        }))
      : _createCommentVNode("", true),
    (isShowEditWorkStationModal.value)
      ? (_openBlock(), _createBlock(EditWorkStationDetailsPopup, {
          key: 1,
          postCode: 
        workstationPostcode(
          activeUserWorkstation.value?.user?.userBusinessDetails?.type
        )
      ,
          workstationAddressValue: 
        workstationAddress(
          activeUserWorkstation.value?.user?.userBusinessDetails?.type
        ) !== 'null null'
          ? workstationAddress(
              activeUserWorkstation.value?.user?.userBusinessDetails?.type
            ) || undefined
          : undefined
      ,
          onCloseEditWorkStationModal: toggleEditWorkStationModal
        }, null, 8, ["postCode", "workstationAddressValue"]))
      : _createCommentVNode("", true),
    (showUploadBannerModal.value)
      ? (_openBlock(), _createBlock(UploadTradePassportBannerModal, {
          key: 2,
          onOnClose: onCloseUploadBannerModal
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})